import React from 'react';
import { LuFilter } from 'react-icons/lu';

import { Button } from 'primereact/button';

export { default as DateFilter } from './DateFilter';
export type { DateFilterValue, DateMode } from './DateFilter';
export { FilterStyles } from './styles';

interface SectionProps {
  icon: React.ReactNode;
  title: string;
}

export const Section: React.FC<SectionProps> = ({ icon, title, children }) => (
  <section className="sec">
    <h4>
      {icon}
      {title}
    </h4>
    {children}
  </section>
);

interface FieldProps {
  id: string;
  label: string;
}

export const Field: React.FC<FieldProps> = ({ id, label, children }) => (
  <div className="field-box">
    <label htmlFor={id}>{label}</label>
    {children}
  </div>
);

interface FilterActionsProps {
  active: number;
  submitLabel: string;
  onClear: () => void;
}

export const FilterActions: React.FC<FilterActionsProps> = ({ active, submitLabel, onClear }) => (
  <footer className="search-actions">
    <span className="active-count" aria-live="polite">
      <LuFilter />
      {active === 0
        ? 'Nenhum filtro preenchido'
        : `${active} ${active === 1 ? 'filtro preenchido' : 'filtros preenchidos'}`}
    </span>
    <div className="buttons">
      <Button
        type="button"
        icon="pi pi-undo"
        label="Limpar campos"
        className="p-button-outlined p-button-secondary"
        onClick={onClear}
        disabled={active === 0}
      />
      <Button type="submit" icon="pi pi-search" label={submitLabel} />
    </div>
  </footer>
);
